import Styled from 'styled-components'

const StyledDivBackdrop = Styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  background-color: rgba(0,0,0,0.3);
`

export default StyledDivBackdrop


// WEBPACK FOOTER //
// ./src/components/UI/Backdrop/StyledBackdrop.js